import React from "react";
import { Col, Row } from "react-bootstrap";
function InfoCard({ data }) {

  const cardData = [
    {
      number: `${data.totalUsers ? data.totalUsers : 0}`,
      label: "Total Users",
      icon: "/images/svg/total-users.svg",
      iconClass: "bg-light-danger",
    },
    {
      number: `${data.dau ? data.dau : 0}`,
      label: "DAU (Daily)",
      icon: "/images/svg/dau.svg",
      iconClass: "bg-light-info",
    },
    {
      number: `${data.postsCreated ? data.postsCreated : 0}`,
      label: "Posts Created",
      icon: "/images/svg/posts_created.svg",
      iconClass: "bg-light-info",
    },
    {
      number: `${data.retentionPercentage ? data.retentionPercentage : 0}%`,
      label: "Retention %",
      icon: "/images/svg/retention.svg",
      iconClass: "bg-light-info",
    },
    {
      number: `${data.eventsJoined ? data.eventsJoined : 0}`,
      label: "Events Joined",
      icon: "/images/svg/event_joined.svg",
      iconClass: "bg-light-info",
    },
    {
      number: `${data.eventCreated ? data.eventCreated : 0}`,
      label: "Event Created",
      icon: "/images/svg/event_created.svg",
      iconClass: "bg-light-success",
    },
    {
      number: `${data.mau ? data.mau : 0}`,
      label: "MAU (Monthly)",
      icon: "/images/svg/mau.svg",
      iconClass: "bg-light-danger",
    },
    {
      number: `${data.flaggedContent ? data.flaggedContent : 0}`,
      label: "Flagged Content",
      icon: "/images/svg/flagged_content.svg",
      iconClass: "bg-light-info",
    },
  ];

  return (
    <Row className="g-sm-4 g-3">
      {cardData.map((card, index) => (
        <Col xl={3} sm={6} key={index}>
          <div className="card-wrapper dash-card">
            <div className="card-body">
              <div className="d-flex justify-content-between">
                <h3>{card.number}</h3>
                <div className={`dash-icon ${card.iconClass}`}>
                  <img src={card.icon} alt="icon" />
                </div>
              </div>
              <p>{card.label}</p>
            </div>
          </div>
        </Col>
      ))}
    </Row>
  );
}

export default InfoCard;
